import { useState, useEffect } from 'react'

const breakpoints = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
}

const useBreakpoints = () => {
  const [breakpoint, setBreakpoint] = useState('')

  const updateBreakpoint = (width) => {
    if (width <= breakpoints.sm) setBreakpoint('sm')
    else if (width <= breakpoints.md) setBreakpoint('md')
    else if (width <= breakpoints.lg) setBreakpoint('lg')
    else if (width > breakpoints.lg) setBreakpoint('xl')
    else setBreakpoint('sm')
  }

  const resizeListener = () => {
    updateBreakpoint(window.innerWidth)
  }

  useEffect(() => {
    resizeListener()
  }, [])

  useEffect(() => {
    if (window.attachEvent) {
      window.attachEvent('onresize', resizeListener)
    } else if (window.addEventListener) {
      window.addEventListener('resize', resizeListener)
    }

    return () => {
      if (window.attachEvent) {
        window.removeEventListener('onresize', resizeListener)
      } else {
        window.removeEventListener('resize', resizeListener)
      }
    }
  }, [])

  return breakpoint
}

export default useBreakpoints
